module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI3LjMxIiBoZWlnaHQ9IjEyLjk5NiIgdmlld0JveD0iMCAwIDcuMzEgMTIuOTk2Ij4KICAgIDxnIGlkPSJwcmVmaXhfX3NvcnQtZG93biIgdHJhbnNmb3JtPSJyb3RhdGUoLTkwIDYuNDk4IDYuNDk4KSI+CiAgICAgICAgPHBhdGggaWQ9InByZWZpeF9fUGF0aF8yMDI5IiBkPSJNMTIuNzU1IDcuMDY5YS43OC43OCAwIDAgMS0uNTcxLjI0MUguODEyYS43OC43OCAwIDAgMS0uNTcxLS4yNDEuOC44IDAgMCAxIDAtMS4xNDJMNS45MjcuMjQxYS44LjggMCAwIDEgMS4xNDIgMGw1LjY4NiA1LjY4NmEuOC44IDAgMCAxIDAgMS4xNDJ6IiBkYXRhLW5hbWU9IlBhdGggMjAyOSIgc3R5bGU9ImZpbGw6I2ZmMCIvPgogICAgPC9nPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/icon/arrow-back-full-yellow.svg
// module id = sD0F
// module chunks = 0